import axios from "axios";
import buildUrl from "build-url-ts";
import {
  DealRoomMentionsSearchRequest,
  DealRoomMentionsSearchResponse,
} from "src/types/settings/dealRoomMentionsSearch";

const DEAL_ROOM_API_BASE = process.env.REACT_APP_DEAL_ROOM_API_URL;


export const dealRoomMentionsSearchApiService = {
  searchDealRoomMentions: async (
    payload: DealRoomMentionsSearchRequest
  ): Promise<DealRoomMentionsSearchResponse> => {
    const { id, query, page = 0, limit = 20, type = "people" } = payload;
    const url = buildUrl(`${DEAL_ROOM_API_BASE}/dealrooms/3.0/${id}/search`, {
      queryParams: {
        page,
        limit,
        type,
        query,
      },
    });
    const response = await axios.get<DealRoomMentionsSearchResponse>(url);
    return response.data;
  },
};
